export const PAGE_ELEMENT_ID = 'pageContent';
